import React, { useContext, useEffect, useState } from "react";
import Form from "react-bootstrap/Form";
import ic_close_red from "../../assets/images/ic_close_red.svg";
import ic_add_plus from "../../assets/images/ic_add_plus.svg";
import ic_arrow_right_white from "../../assets/images/ic_right_arrow_circle.svg";
import dummyProfile from "../../assets/images/dummyProfile.webp";
import Select from "react-select";
import { json, Link, useNavigate } from "react-router-dom";
import ApiConfig from "../../api/ApiConfig";
import {
  deleteWithAuthCall,
  GetWithAuth,
  PostWithAuth,
  postWithAuthCall,
  postWithAuthCallWithErrorResponse,
  putMultipartWithAuthCall,
  putMultipartWithAuthCallWithErrorResponse,
  PutWithAuthMultipart,
  simpleGetCall,
  simpleGetCallWithErrorResponse,
  simplePostCall,
  simplePostCallLandmark,
} from "../../api/ApiServices";
import { Delete } from "lucide-react";
import { Button, Spinner } from "react-bootstrap";
import { SearchAddress } from "./SearchAddress ";
import { notifyError, notifySuccess } from "../../sharedComponent/notify";
import { OpenStreetMapProvider } from "leaflet-geosearch";
import { AppContext } from "../../context/AppContext";
import ConfirmModal from "../../sharedComponent/ConfirmModal";

const MyProfileComp = () => {
  const Data = JSON.parse(localStorage.getItem("LOGIN_DATA"));
  const { set_selected_location, selected_location } = useContext(AppContext);
  const [profileData, setProfileData] = useState([]);
  console.log("profileData",profileData);
  const [isPhoneChanged, setIsPhoneChanged] = useState(false);
  const [query, setQuery] = useState("");
  const [updateProfileLoading, setUpdateProfileLoading] = useState(false);
  useEffect(() => {
    loadProfileDetails();
  }, []);

  const navigate = useNavigate();

  const [addressList, setAddressList] = useState([
    {
      first_name: "",
      gender: "",
      location: "",
      phone_number: "",
    },
  ]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setProfileData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  console.log("addressList", addressList);
  const [pincodeList, setPincodeList] = useState([]);
  const [refresh, setRefresh] = useState(false);
  // 1) expanded form state (replace your existing formData useState)
  const [formData, setFormData] = useState({
    id: null, // local id for UI; update payload uses user_address_id for update
    user_address: "",
    pin_code: "",
    city: "",
    user_street: "",
    landmark: "",
    user_address_type: "work", // use 'work' | 'home' | 'other' as in API
    user_latitude: "", // required by API
    user_longitude: "", // required by API
    user_address_mobile: "", // phone
    user_address_user_name: "", // name
    user_house_address: "", // house address field
    delivery_intructions: "", // delivery instructions
    user_address_is_default: 0, // 0 or 1
    user_city_list: [],
    user_rs_id:"",
    address_line1:"",
    address_line2:"",
    user_address_user_name:"",
  });
  console.log("formData", formData);

  useEffect(() => {
    loadAddressList();
  }, [refresh]);

  const loadAddressList = async () => {
    const res = await simpleGetCallWithErrorResponse(
      ApiConfig.CREATE_OR_GET_UPDATE_ADDRESS
    );
    if (res?.json.success) {
      setAddressList(res.json?.data);
      // let filter = res?.json.data?.filter((i) => i?.user_address_is_default == 1);
      //       if (filter?.length > 0) {
      //         // dispatch(setLocation({ selected_location: filter?.[0] }));
      //         localStorage.setItem.setItem(
      //           'SELECTED_LOCATION',
      //           JSON.stringify(filter?.[0])
      //         );
      //         // navigation.navigate("DrawerScreen");
      //       }
    } else notifyError("Failed to fetch addresses");
  };

  // Get location from browser

  const deleteAddress = async () => {
    if (!selectedItem) return;
    setDeleteAddressLoading(true);
    const res = await deleteWithAuthCall(
      `${ApiConfig.CREATE_OR_GET_UPDATE_ADDRESS}/${selectedItem.id}`
    );
    if (res?.success) {
      notifySuccess("Address deleted successfully");
      setDeleteAddressLoading(false);
      handleCancel();

      loadAddressList();
    } else {
      notifyError(res?.message || "Error deleting address");
      setDeleteAddressLoading(false);
    }
  };

  const handleUpdateDefault = async (selectedLocation) => {
    const updatedList = addressList.map((i) => ({
      ...i,
      user_address_is_default: i.id === selectedLocation.id ? 1 : 0,
    }));
    setAddressList(updatedList);
    setRefresh(!refresh);
    localStorage.setItem(
      "user_selected_location",
      JSON.stringify(selectedLocation)
    );
    set_selected_location(selectedLocation);
    try {
      const res = await putMultipartWithAuthCallWithErrorResponse(
        `${ApiConfig.CREATE_OR_GET_UPDATE_ADDRESS}/${selectedLocation.id}`,
        JSON.stringify({ ...selectedLocation, user_address_is_default: 1 })
      );

      if (res.json?.success) {
        //  setAddressList(res?.data)
        notifySuccess("Location Set successfully");

        loadAddressList();
      }
    } catch (e) {
      console.error(e);
      loadAddressList();
    }
  };

  // Handle Form Input
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  // Handle Add / Update Address
  // 3) updated handleSubmit that maps to Add and Update payloads
  const handleSubmit = async () => {
    if (!formData.user_address.trim())
      return notifyError("Please enter address.");

    // common fields for create/update
    // Note: API wants different key for update (user_address_id)
    if (formData.id) {
      // Update payload (example you provided)
      const updatePayload = {
        user_address_id: formData.id, // <-- IMPORTANT for update
        user_address: formData.user_address,
        user_address_user_name: formData.user_address_user_name,
        pin_code: formData.pin_code,
        city: formData.city,
        landmark: formData.landmark,
        address_line1: formData.address_line1,
        address_line2: formData.address_line2,
        user_latitude: formData.user_latitude || "",
        user_longitude: formData.user_longitude || "",
        user_address_type: formData.user_address_type || "work",
        user_address_mobile: formData.user_address_mobile || "",
        user_address_user_name: formData.user_address_user_name || "",
        user_house_address: formData.user_house_address || "",
        delivery_intructions: formData.delivery_intructions || "",
        user_address_is_default: formData.user_address_is_default ? 1 : 0,
      };

      try {
        const res = await putMultipartWithAuthCallWithErrorResponse(
          `${ApiConfig.CREATE_OR_GET_UPDATE_ADDRESS}/${formData.id}`,
          JSON.stringify(updatePayload)
        );
        if (res?.json.success) {
          notifySuccess("Address updated successfully!");
          setQuery("");
          setFormData({
            id: null, // local id for UI; update payload uses user_address_id for update
            user_address: "",
            user_address_user_name: "",
            city:"",
            address_line1:"",
            address_line2:"",
            pin_code: "",
            user_street: "",
            landmark: "",
            user_address_type: "work", // use 'work' | 'home' | 'other' as in API
            user_latitude: "", // required by API
            user_longitude: "", // required by API
            user_address_mobile: "", // phone
            user_address_user_name: "", // name
            user_house_address: "", // house address field
            delivery_intructions: "", // delivery instructions
            user_address_is_default: 0, // 0 or 1
          });

          setResults([]);

          setFormData({
            id: null,
            user_address: "",
            city: "",
            address_line1:"",
            address_line2:"",
            pin_code: "",
            user_street: "",
            landmark: "",
            user_address_type: "work",
            user_latitude: "",
            user_longitude: "",
            user_address_mobile: "",
            user_address_user_name: "",
            user_house_address: "",
            delivery_intructions: "",
            user_address_is_default: 0,
          });
          loadAddressList();
        } else {
          alert(res?.message || "Failed to update address");
        }
      } catch (e) {
        console.error(e);
        alert("Failed to update address");
      }
    } else {
      // Create payload (example you provided)
      const createPayload = {
        user_address: formData.user_address,
        address_line1: formData.address_line1,
        address_line2: formData.address_line2,
        user_latitude: formData.user_latitude || "",
        user_longitude: formData.user_longitude || "",
        user_address_type: formData.user_address_type || "work",
        user_address_mobile: `+91${formData.user_address_mobile}` || "",
        user_address_user_name: formData.user_address_user_name || "",
        user_house_address: formData.user_house_address || "",
        city: formData.city || "",
        pin_code: formData.pin_code || "",
        landmark: formData.landmark || "",
        delivery_intructions: formData.delivery_intructions || "",
        user_address_is_default: formData.user_address_is_default ? "" : "",
        // your example had "" for create; adjust if backend expects 0/1 or empty
      };

      try {
        // your code used postWithAuthCall(JSON.stringify(payload))
        const res = await postWithAuthCallWithErrorResponse(
          ApiConfig.CREATE_OR_GET_UPDATE_ADDRESS,
          JSON.stringify(createPayload)
        );
        if (res?.json.success) {
          notifySuccess("Address added successfully!");
          setResults([]);

          setFormData({
            id: null,
            user_address: "",
            address_line1:"",
            city:"",
            address_line2:"",
            pin_code: "",
            user_street: "",
            landmark: "",
            user_address_type: "work",
            user_latitude: "",
            user_longitude: "",
            user_address_mobile: "",
            user_address_user_name: "",
            user_house_address: "",
            delivery_intructions: "",
            user_address_is_default: 0,
          });
          loadAddressList();
        } else {
          alert(res?.message || "Failed to add address");
        }
      } catch (e) {
        console.error(e);
        alert("Failed to add address");
      }
    }
  };

  const handleEdit = (item) => {
    console.log("item", item);

    setQuery(item.user_address ?? "");
    setFormData({
      id: item.id ?? null,
      user_address: item.user_address ?? "",
      landmark: item.landmark ?? "",
      address_line1: item.address_line1 ?? "",
      city: item.city ?? "",
      address_line2: item.address_line2 ?? "",
      pin_code: item.pin_code ?? "",
      user_street: item.user_street ?? "",
      user_address_type: item.user_address_type ?? "work",
      user_latitude: item.user_latitude ?? "",
      user_longitude: item.user_longitude ?? "",
      user_address_mobile: item.user_address_mobile ?? "",
      user_address_user_name: item.user_address_user_name ?? "",
      // user_landmark: item.user_landmark ?? "",


      user_house_address: item.user_house_address ?? "",
      delivery_intructions: item.delivery_intructions ?? "",
      // API expects 1/0 for default
      user_address_is_default: item.user_address_is_default ? 1 : 0,
    });
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const provider = new OpenStreetMapProvider();

  const [results, setResults] = useState([]);

  const searchPlace = async (input) => {
    if (!input || input.length < 3) {
      setResults([]);
      return;
    }
    try {
      const searchResults = await provider.search({ query: input });

      setResults(searchResults);
    } catch (error) {
      console.error("Address search failed:", error);
    }
  };

  const handleSelect = (place) => {
    setQuery(place.label || place.display_name || "");
    setResults([]);

    const updatedData = {
      ...formData,
      user_address: place.label || place.display_name || "",
      user_latitude: place.y,
      user_longitude: place.x,
      // user_city: place.raw.name,
    };

    setFormData(updatedData);

    console.log("Updated formData:", updatedData);
  };

  useEffect(() => {
    const timeout = setTimeout(() => {
      searchPlace(query);
    }, 400);

    return () => clearTimeout(timeout);
  }, [query.toLocaleLowerCase()]);

  // //////////////////////EDIT PROFILE ////////////////////////////////////////////////

  // const profileData = useSelector((state) => state.auth.profileData);
  // const dispatch = useDispatch();

  const [name, setName] = useState(profileData?.data?.first_name || "");
  const [phone, setPhone] = useState(
    profileData?.data?.phone_number?.replace("+91", "") || ""
  );
  const [phoneOriginal, setPhoneOriginal] = useState(
    profileData?.data?.phone_number?.replace("+91", "") || ""
  );
  const [email, setEmail] = useState(profileData?.data?.email || "");
  const [otp, setOTP] = useState("");
  const [selectedProfile, setSelectedProfile] = useState(null);
  const [SelectedLandmArk, setSelectedLandmArk] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingUpdate, setIsLoadingUpdate] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const loadProfileDetails = async () => {
    try {
      let res = await GetWithAuth(ApiConfig.GET_PROFILE);
      if (res?.success) {
        setProfileData(res?.data);
        localStorage.setItem(
          "user_profile_img_url",
          JSON.stringify(res?.data?.profile_path)
        );
        setPhone(res?.data?.phone_number.replace("+91", "") || "");
        console.log("res?.data?.phone_number--", res?.data?.phone_number);

        setPhoneOriginal(res?.data?.phone_number.replace("+91", "") || "");
      }
    } catch (e) {
      console.error(e);
    }
  };

  const handleSendOTP = async () => {
    const phone = profileData?.phone_number?.replace("+91", "") || "";
    if (!/^\d{10}$/.test(phone)) {
      notifyError("Invalid phone number");
      return;
    }
    setIsLoading(true);
    try {
      const requestBody = {
        phoneNumber: "+91" + phone,
        Hash: "sdfdsfsd",
      };
      let res = await simplePostCall(
        ApiConfig.SEND_OTP,
        requestBody,
        setIsLoading
      );
      setIsLoading(false);
      if (res?.success) {
        setOTP(res?.otp ?? "");
        notifySuccess(res?.message);
      } else {
        notifyError(res?.message);
      }
    } catch (e) {
      notifyError("Failed to send OTP");
      setIsLoading(false);
    }
  };
const pincodeOptions = pincodeList.map((pin) => ({
  value: pin,
  label: pin,
}));
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) setSelectedProfile(file);
  };

  const handleUpdate = async () => {
    const phone = profileData?.phone_number?.replace("+91", "") || "";
    const email = profileData.email;
    console.log("phone--", phone, profileData);
    if (!/^\d{10}$/.test(phone)) {
      notifyError("Invalid phone number");
      return;
    }

    const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
    if (!emailPattern.test(email)) {
      notifyError("Invalid email");
      return;
    }
    setUpdateProfileLoading(true);
    const formData = new FormData();
    formData.append("otp", phoneOriginal !== phone ? otp : "");
    formData.append("email", email);
    formData.append("phoneNumber", "+91" + phone);
    formData.append("fullName", profileData.first_name);
    if (selectedProfile) {
      formData.append("profilePath", selectedProfile);
    }

    try {
      setIsLoadingUpdate(true);
      let res = await PutWithAuthMultipart(ApiConfig.UPDATE_PROFILE, formData);
      setIsLoadingUpdate(false);
      if (res?.success) {
        notifySuccess(res?.message);
        await loadProfileDetails();
        if (navigate /*  navigate(-1) */);
      } else {
        notifyError(res?.message);
      }
    } catch (e) {
      notifySuccess(e?.message || "Update failed");
      setIsLoadingUpdate(false);
    } finally {
      setUpdateProfileLoading(false);
    }
  };

  // //////////////////////////////////////////////////////////////////////////////////

  // ////////////////delete popup/////////////////////////
  const [showConfirm, setShowConfirm] = useState(false);
  const [deleteAddressLoading, setDeleteAddressLoading] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [inGeofence, setInGeofence] = useState(null); // For geofence result
  const handleCancel = () => {
    setShowConfirm(false);
    setSelectedItem(null);
  };
  const handleShowConfirm = (item) => {
    setSelectedItem(item);
    setShowConfirm(true);
  };

  const [UserLocationdetected, setUserLocationdetected] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const INDIAN_CITIES_BY_STATE = {
    Kerala: ["Thiruvananthapuram", "Kozhikode"],
    Maharashtra: [
      "Mumbai",
      "Pune",
      "Nagpur",
      "Nashik",
      "Aurangabad",
      "Solapur",
      "Amravati",
      "Kolhapur",
      "Sangli",
      "Thane",
      "Navi Mumbai",
    ],
    Delhi: ["New Delhi", "Delhi"],
    Karnataka: [
      "Bengaluru",
      "Mysuru",
      "Hubli",
      "Mangaluru",
      "Belagavi",
      "Kalaburagi",
    ],
    Gujarat: [
      "Ahmedabad",
      "Surat",
      "Vadodara",
      "Rajkot",
      "Bhavnagar",
      "Jamnagar",
    ],
    "Tamil Nadu": [
      "Chennai",
      "Coimbatore",
      "Madurai",
      "Tiruchirappalli",
      "Salem",
      "Tirunelveli",
    ],
    "West Bengal": ["Kolkata", "Howrah", "Durgapur", "Asansol", "Siliguri"],
    Rajasthan: ["Jaipur", "Jodhpur", "Udaipur", "Kota", "Ajmer", "Bikaner"],
    "Uttar Pradesh": [
      "Lucknow",
      "Kanpur",
      "Agra",
      "Varanasi",
      "Prayagraj",
      "Meerut",
      "Ghaziabad",
      "Noida",
    ],
    Punjab: ["Ludhiana", "Amritsar", "Jalandhar", "Patiala", "Bathinda"],
    Haryana: ["Gurgaon", "Faridabad", "Panipat", "Ambala", "Yamunanagar"],
  };

  const cityPincodeData = {
    Kozhikode: [
      "673001",
      "673020",
      "673002",
      "673003",
      "673005",
      "673006",
      "673008",
      "673011",
      "673016",
      "673015",
      "673317",
      "673021",
    ],
    Thiruvananthapuram: [
      "695001",
      "695034",
      "695035",
      "695003",
      "695005",
      "695002",
      "695004",
      "695023",
      "695014",
      "695009",
    ],
  };

  const handleCityChange = (data) => {
    // const city = e.target.value;
    // loadLandmakrDetails(city);
    setFormData((prev) => ({
      ...prev,
      city: (data == "Trivandrum" || data === "Thiruvananthapuram") ? "Thiruvananthapuram":"Kozhikode",
      pin_code: "",
    }));

    setPincodeList(cityPincodeData[ (data == "Trivandrum" || data === "Thiruvananthapuram") ? "Thiruvananthapuram":"Kozhikode"] || []);
  };




useEffect(() => {
  // 1. Get the string from localStorage
  const storedData = localStorage.getItem('store_Location');
  console.log("storedData",storedData)
  if (storedData) {
    try {
      // 2. Parse the JSON string into an object
      const locationObj = JSON.parse(storedData);

      // 3. Update your formData with the restaurant_city
      setFormData(prev => ({
        ...prev,
        city: locationObj[0].restaurant_city,
        user_rs_id:locationObj[0].delivery_user_id
      }));

      // 4. Trigger any side effects (like loading landmarks)
      loadLandmakrDetails(locationObj[0].restaurant_city);
      handleCityChange(locationObj[0].restaurant_city)
      
    } catch (error) {
      console.error("Error parsing store_Location from localStorage", error);
    }
  }
}, []); // Empty dependency array means this runs once on mount



  const getUserLocation = () => {
    setLoading(true);
    setError(null);
    setUserLocationdetected(true);
    setFormData((prev) => ({
      ...prev,
      user_city_list: [],
      user_state: "",
      city: "",
    }));

    if (!navigator.geolocation) {
      setError("Geolocation not supported");
      setLoading(false);
      return;
    }

    navigator.geolocation.getCurrentPosition(
      async (position) => {
        const lat = position.coords.latitude;
        const lon = position.coords.longitude;

        try {
          const response = await fetch(
            `https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lon}&addressdetails=1&zoom=18`,
            {
              headers: {
                // CHANGE THIS TO YOUR APP NAME + EMAIL (required by OSM)
                "User-Agent": "MyDeliveryApp/1.0 (your-email@gmail.com)",
              },
            }
          );

          if (!response.ok) throw new Error("API error");

          const data = await response.json();
          const addr = data.address || {};
  setUserLocationdetected(false);
          // Correctly extract city (Nominatim uses different keys)
          const detectedCity =
            addr.city ||
            // Most common
            addr.town ||
            addr.village ||
            addr.hamlet ||
            addr.suburb ||
            addr.city_district ||
            "Unknown City";

          // Correctly extract state
          const detectedState =
            addr.state || addr.province || addr.region || "Unknown State";

          const pincode = addr.postcode || "N/A";
          const country = addr.country || "";

          // Only for India (you can remove this if global)
          if (country !== "India" && country !== "भारत") {
            setError("Service available only in India");
            setLoading(false);
            return;
          }

          // Get list of cities for this state
          const cityList = INDIAN_CITIES_BY_STATE[detectedState] || ["Kerala"];

          // Update your form/state
          setFormData({
            user_latitude: lat,
            user_longitude: lon,
            city: detectedCity,
            user_state: detectedState,
            pin_code: pincode,
            user_street: addr.road || addr.neighbourhood || addr.suburb || "",
            fullAddress: data.display_name || "",
            user_city_list: cityList, // This is what you wanted!
          });

          console.log("State:", detectedState);
          console.log("Detected City:", detectedCity);
          console.log("All Cities in State:", cityList);
        } catch (err) {
          console.error(err);
          setError("Failed to get location details");
          const cityList = INDIAN_CITIES_BY_STATE["Kerala"] || ["Kerala"];
          setFormData({
            user_latitude: lat,
            user_longitude: lon,
            city: "Kerala",
            user_state: "Kerala",
            pin_code: "673001",
            // user_street: addr.road || addr.neighbourhood || addr.suburb || "",
            // fullAddress: data.display_name || "",
            user_city_list: cityList, // This is what you wanted!
          });
        } finally {
          setLoading(false);
        }
      },
      (err) => {
        let msg = "Location access denied";
        if (err.code === 1) msg = "Please allow location permission";
        if (err.code === 2) msg = "Location not available";
        if (err.code === 3) msg = "Request timeout";
        setError(msg);
        setLoading(false);
      },
      {
        enableHighAccuracy: true,
        timeout: 15000,
        maximumAge: 0,
      }
    );
  };

  const loadLandmakrDetails = async (landmark) => {
   
    console.log("Call Api",landmark)
    const requestBody = {
      location_address:landmark == "Trivandrum"? "Thiruvananthapuram":landmark,
    };

    try {
      let res = await simplePostCallLandmark(
        ApiConfig.GET_RESTAURANT_Landmark,
        JSON.stringify(requestBody)
      );
      console.log("API Success:", res);
      if (res?.result) {
        setSelectedLandmArk(res.data);
      } else {
        setSelectedLandmArk([]);
      }
    } catch (e) {
      console.log("API Error:", e);
      return false;
    }
  };

useEffect(() => {
  if (profileData?.phone_number) {
    const original = profileData.phone_number.replace("+91", "");
    setPhone(original);
    setPhoneOriginal(original);
  }
}, [profileData]);
useEffect(() => {
  // If we have a profile phone and the form field is currently empty
  if (profileData?.phone_number && !formData.user_address_mobile) {
    const cleanNumber = profileData.phone_number.replace("+91", "").trim();
    setFormData(prev => ({
      ...prev,
      user_address_mobile: cleanNumber
    }));
  }
}, [profileData]); // This runs when profileData is loaded
  return (
    <div>
      <div className="right-section">
        <section className="wrapper-cards">
          <div className="d-flex justify-content-between align-items-start">
            <h5>My Profile</h5>

            <div className="profile-pic-section">
              <label htmlFor="profilePic" className="profile-pic-label">
 
                  <img
  src={
    selectedProfile
      ? URL.createObjectURL(selectedProfile)
      : profileData?.profile_path
      ? `${ApiConfig.BASE_URL}/${profileData.profile_path}`
      : dummyProfile
  }
  alt="Profile"
  className="profile-pic"
  onError={(e) => {
    e.currentTarget.src = dummyProfile;
  }}
/>
                
                <span className="edit-icon">✎</span>
              </label>
              <input
                id="profilePic"
                type="file"
                accept="image/*"
                className="file-input "
                onChange={handleFileChange}
              />
            </div>
          </div>
          <div className="row inputBox ">
            <div className="col-md-6 form-group">
              <Form.Group className="formInput">
                <Form.Label>First Name </Form.Label>
                <Form.Control
                  type="text"
                  placeholder=""
                  value={profileData.first_name}
                  name="first_name"
                  onChange={handleChange}
                  className="form-control formInput"
                />
              </Form.Group>
            </div>
            {/* <div className="col-md-6 form-group">
              <Form.Group className="">
                <Form.Label>Gender</Form.Label>
                <Form.Control type="text" placeholder="" value={profileData.gender}
                 name="gender"
                   onChange={handleChange}
                />
              </Form.Group>
            </div> */}
            <div className="col-md-6 form-group">
              <Form.Group className="">
                <Form.Label>Email</Form.Label>
                <Form.Control
                  type="text"
                  placeholder=""
                  value={profileData.email}
                  name="email"
                  onChange={handleChange}
                  className="form-control formInput"
                />
              </Form.Group>
            </div>
            <div className="col-md-6 form-group">
              <Form.Group className="">
                <Form.Label>Contact Number</Form.Label>
                <Form.Control
                  type="text"
                  placeholder=""
                  value={profileData.phone_number}
                  name="phone_number"
                  className="form-control formInput"
                  onChange={handleChange}
                />
              </Form.Group>

             {isPhoneChanged && (
  <button
    className="otp-btn mt-2"
    style={{
      border: "none",
      backgroundColor: "#f9bc03",
      color: "#fff",
      width: "260px",
      height: "42px",
      borderRadius: "20px",
    }}
    onClick={handleSendOTP}
    disabled={isLoading}
  >
    {isLoading ? "Sending..." : "Send OTP"}
  </button>
)}
            </div>
          </div>

        {isPhoneChanged && (
  <div className="form-group">
    <label>OTP</label>
    <input value={otp} onChange={(e) => setOTP(e.target.value)} />
  </div>
)}
          <div className="mt-4 text-end">
            <Button
              style={{
                border: "none",
                backgroundColor: "#f9bc03",
                color: "#fff",
                width: "260px",
                height: "42px",
                borderRadius: "20px",
              }}
              disabled={updateProfileLoading}
              onClick={handleUpdate}
            >
              {updateProfileLoading ? <Spinner size="sm" /> : "Update Profile"}
            </Button>
          </div>
        </section>
        <div className="wrapper-cards mt-4">
          {/* Header */}

          {/* Add New Address */}
          <div className="wrapper-cards mt-4">
            {/* Header */}

            {/* Add/Edit Address */}
            <section className="wrapper-cards mt-3 p-3 border rounded bg-white shadow-sm">
              {/* <div className="d-flex justify-content-between align-items-center mb-3">
                <h5>{formData.id ? "Edit Address" : "Add New Address"}</h5>
                <button
                  onClick={getUserLocation} // Define this function in Step 2
                  disabled={loading}
                  style={{
                    padding: "12px 24px",
                    fontSize: "16px",
                    backgroundColor: "#007bff",
                    color: "white",
                    border: "none",
                    borderRadius: "8px",
                    cursor: loading ? "not-allowed" : "pointer",
                    width: "150px",
                  }}
                >
                  {loading ? "Fetching..." : "Get Location"}
                </button>
              </div> */}

              <div className="row">


                  <div className="col-md-12 form-group">
                      {/* Address hint banner */}
                <div className="col-12 mb-2">
                  <div
                    style={{
                      display: "flex",
                      alignItems: "flex-start",
                      gap: "10px",
                      backgroundColor: "rgba(249, 188, 3, 0.08)",
                      border: "1px solid rgba(249, 188, 3, 0.4)",
                      borderRadius: "10px",
                      padding: "10px 14px",
                    }}
                  >
                    <span style={{ fontSize: "18px", lineHeight: "1.4" }}>💡</span>
                    <div style={{ fontSize: "13px", color: "#444", lineHeight: "1.6" }}>
                      <strong style={{ color: "#b88a00" }}>How to set your address:</strong>
                      <ol style={{ margin: "4px 0 0 0", paddingLeft: "18px" }}>
                        <li>Select your <strong>Pin Code</strong> from the dropdown.</li>
                        <li>Then select a <strong>Landmark</strong> — your address will be filled in automatically.</li>
                      </ol>
                    </div>
                  </div>
                </div>


<Form.Group>
                        <Form.Label>
                          Address (Area, Flat No., Street, ...) *
                        </Form.Label>
                  
                        <div style={{ position: "relative", width: "100%" }}>
                          {/* <input
                            type="text"
                            className="form-control"
                            placeholder="Search address..."
                            value={query}
                            onChange={(e) => setQuery(e.target.value)}
                          /> */}
                          <input
  type="text"
  className="form-control"
  placeholder="Search address..."
  // Use formData instead of query
  value={formData.user_address} 
  onChange={(e) => {
    const val = e.target.value;
    setQuery(val); // Keep this for your search results logic
    setFormData({...formData, user_address: val}); // Update form object
  }}
/>

                          {results.length > 0 && (
                            <ul
                              style={{
                                position: "absolute",
                                top: "100%",
                                left: 0,
                                right: 0,
                                background: "#fff",
                                border: "1px solid #ccc",
                                borderRadius: "4px",
                                listStyle: "none",
                                margin: 0,
                                padding: "5px 0",
                                maxHeight: "200px",
                                overflowY: "auto",
                                zIndex: 9999,
                              }}
                            >
                              {results.map((r, index) => (
                                <li
                                  key={index}
                                  onClick={() => handleSelect(r)}
                                  style={{
                                    padding: "8px 12px",
                                    cursor: "pointer",
                                    borderBottom: "1px solid #eee",
                                  }}
                                >
                                  {r.label || r.display_name}
                                </li>
                              ))}
                            </ul>
                          )}
                        </div>
                      </Form.Group>
                </div>
                <div className="col-md-6 form-group mt-3">
                  {/* {UserLocationdetected === false ? (
                    <>
                      <Form.Group>
                        <Form.Label>
                          Address (Area, Flat No., Street, ...)
                        </Form.Label>
                  
                        <div style={{ position: "relative", width: "100%" }}>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Search address..."
                            value={query}
                            onChange={(e) => setQuery(e.target.value)}
                          />

                          {results.length > 0 && (
                            <ul
                              style={{
                                position: "absolute",
                                top: "100%",
                                left: 0,
                                right: 0,
                                background: "#fff",
                                border: "1px solid #ccc",
                                borderRadius: "4px",
                                listStyle: "none",
                                margin: 0,
                                padding: "5px 0",
                                maxHeight: "200px",
                                overflowY: "auto",
                                zIndex: 9999,
                              }}
                            >
                              {results.map((r, index) => (
                                <li
                                  key={index}
                                  onClick={() => handleSelect(r)}
                                  style={{
                                    padding: "8px 12px",
                                    cursor: "pointer",
                                    borderBottom: "1px solid #eee",
                                  }}
                                >
                                  {r.label || r.display_name}
                                </li>
                              ))}
                            </ul>
                          )}
                        </div>
                      </Form.Group>
                    </>
                  ) : (
                    <>
                      <Form.Group>
                        <Form.Label>
                          Address (Area, Flat No., Street, ...)
                        </Form.Label>
                     

                        

                        <div style={{ position: "relative", width: "100%" }}>
                          <input
                            type="text"
                            className="form-control"
                            name="user_address"
                            placeholder="Search address..."
                            value={formData.fullAddress}
                            onChange={handleInputChange}
                          />
                        </div>
                      </Form.Group>
                    </>
                  )} */}

  <Form.Group>
                        <Form.Label>
                          Address Line 1
                        </Form.Label>
                     

                        

                        <div style={{ position: "relative", width: "100%" }}>
                          <input
                            type="text"
                            className="form-control"
                            name="address_line1"
                            placeholder="Enter Address"
                            value={formData.address_line1}
                            onChange={handleInputChange}
                          />
                        </div>
                      </Form.Group>

                 
                </div>
              
  <div className="col-md-6 form-group mt-3">
                  <Form.Group>
                        <Form.Label>
                          Address Line 2
                        </Form.Label>
                     

                        

                        <div style={{ position: "relative", width: "100%" }}>
                          <input
                            type="text"
                            className="form-control"
                            name="address_line2"
                            placeholder="Enter Address"
                            value={formData.address_line2}
                            onChange={handleInputChange}
                          />
                        </div>
                      </Form.Group>
                </div>
  <div className="col-md-6 form-group mt-3">
                  <Form.Group>
                    <Form.Label>Contact Name *</Form.Label>
                    <Form.Control
                      type="text"
                      name="user_address_user_name"
                      placeholder="Enter contact name"
                      value={formData.user_address_user_name}
                      onChange={handleInputChange}
                    />
                  </Form.Group>
                </div>

             <div className="col-md-6 form-group mt-3">
 <Form.Group>
  <Form.Label>Phone Number *</Form.Label>
  <Form.Control
    type="text"
    name="user_address_mobile"
    placeholder="Enter phone number"
    // Always point to state. The useEffect handles the "Default" value.
    value={formData.user_address_mobile} 
    maxLength={10}
    onChange={(e) => {
      // Remove everything except numbers
      const value = e.target.value.replace(/\D/g, ""); 

      if (value.length <= 10) {
        setFormData({
          ...formData,
          user_address_mobile: value,
        });
      }
    }}
  />
  
  {/* Validation Message (Uncomment to use) */}
  {formData.user_address_mobile.length > 0 && formData.user_address_mobile.length < 10 && (
    <small className="text-danger">
      Mobile number must be 10 digits
    </small>
  )}
</Form.Group>
</div>


                    <div className="col-md-6 form-group mt-3">
                <Form.Label>Address Type</Form.Label>
              
                <div style={{ display: "flex", gap: "12px" }}>
                  {["Home", "Work", "Other"].map((type) => {
                    const isActive = formData.user_address_type === type;
              
                    return (
                      <button
                        key={type}
                        type="button"
                        onClick={() =>
                          setFormData({
                            ...formData,
                            user_address_type: type,
                          })
                        }
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "6px",
                          padding: "10px 18px",
                          borderRadius: "8px",
                          border: isActive ? "2px solid #f9bc03" : "1px solid #ddd",
                          backgroundColor: isActive ? "#f8f8f8" : "#fff",
                          cursor: "pointer",
                          fontWeight: "500",
                          transition: "all 0.2s ease",
                          
                        }}
                      >
                        {type === "Home" && <i className="bi bi-house"></i>}
                        {type === "Work" && <i className="bi bi-briefcase"></i>}
                        {type === "Other" && <i className="bi bi-geo-alt"></i>}
                        <span>{type}</span>
                      </button>
                    );
                  })}
                </div>
              </div>

                
                  <>
                  <div className="col-md-6 form-group mt-3">
  <Form.Group>
    <Form.Label>
      Selected City 
    </Form.Label>
    {/* Replaced Select with a Read-Only Control */}
    <Form.Control 
      type="text" 
      value={formData.city || "Loading..."} 
      readOnly 
      className="bg-light"
    />
    <small className="text-muted">City automatically loaded from store location.</small>
  </Form.Group>
</div>
                  </>
               

                {/* )} */}

              
<div className="col-md-6 form-group mt-3">

  <Form.Group>
    <Form.Label>
      Pin Code :
    </Form.Label>

    <Select
      styles={customStyles} // Apply the custom styles here
      options={pincodeOptions}
      placeholder="Search Pin Code..."
      isSearchable
      value={pincodeOptions.find(opt => opt.value === formData.pin_code)}
      onChange={(selected) =>
        setFormData({
          ...formData,
          pin_code: selected ? selected.value : "",
        })
      }
    />
  </Form.Group>
</div>

                {/* {SelectedLandmArk.length > 0 && ( */}
                <div className="col-md-6 form-group mt-3">
               <Form.Group>
  <Form.Label>Landmark :</Form.Label>
  
  <Select
    styles={customStyles} // Using your existing custom styles
    placeholder="Search Landmark..."
    isSearchable
    // 1. Convert your landmarks into react-select options format
    options={SelectedLandmArk?.map((item) => ({
      value: item.location_name,
      label: item.location_name,
      ...item, // Keep original data attached for easy access
    }))}
    
    // 2. Map the current state back to the select value
    value={
      formData.landmark 
        ? { value: formData.landmark, label: formData.landmark } 
        : null
    }
    
    // 3. Handle selection and update all related fields
    onChange={(selected) => {
      if (selected) {
        setFormData({
          ...formData,
          landmark: selected.value,
          user_latitude: selected.location_latitude || "",
          user_longitude: selected.location_longitude || "",
          user_address: selected.location_address
        });

        // Sync with the address search query state
        setQuery(selected.location_address);
      } else {
        // Handle clear (if isClearable is added)
        setFormData({
          ...formData,
          landmark: "",
          user_latitude: "",
          user_longitude: "",
          user_address: ""
        });
      }
    }}
  />
</Form.Group>

                </div>
                {/* )} */}
              </div>

              <div className="mt-4 text-end">
                <Button
                  onClick={handleSubmit}
                  style={{
                    border: "none",
                    backgroundColor: "#f9bc03",
                    color: "#fff",
                    width: "260px",
                    height: "42px",
                    borderRadius: "20px",
                  }}
                >
                  {formData.id ? "Update Address" : "Save Address"}
                </Button>
              </div>
            </section>

            {/* Saved Addresses */}
            <section className="wrapper-cards mt-4 p-3 border rounded bg-white shadow-sm">
              <h5>Saved Addresses</h5>
              <div className="row mt-3">
                {addressList.map((item) => (
                  <div
                    key={item.id}
                    className="col-md-6 mb-3"
                    onClick={() => handleUpdateDefault(item)}
                  >
                    <div
                      className={`p-3 rounded border ${
                        item.user_address_is_default === 1
                          ? "bg-light-card-map"
                          : "border-secondary"
                      }`}
                    >
                      <div className="d-flex justify-content-between">
                        <div>
                          <strong>
                            {item.user_address_type?.replace(
                              /\s*\(.*?\)\s*/g,
                              ""
                            )}
                          </strong>
                          <p className="mb-1">{item.user_address}</p>
                        </div>
                        <div className="d-flex align-items-start">
                          <Button
                            size="sm"
                            variant="outline-primary"
                            style={{
                              border: "none",
                              backgroundColor: "#f9bc03",
                              color: "#fff",
                              borderRadius: "20px",
                            }}
                            onClick={(e) => {
                              e.stopPropagation();
                              handleEdit(item);
                            }}
                          >
                            ✎
                          </Button>
                          {item.user_address_is_default !== 1 && (
                            <Button
                              size="sm"
                              variant="outline-danger"
                              className="ms-2"
                              style={{
                                border: "none",
                                backgroundColor: "#c91a1aff",
                                color: "#fff",
                                borderRadius: "20px",
                              }}
                              onClick={(e) => {
                                e.stopPropagation();
                                // deleteAddress(item);
                                handleShowConfirm(item);
                              }}
                            >
                              🗑
                            </Button>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </section>
          </div>

          {/* Saved Addresses */}
        </div>

        {/* <div className="submit-btn-group mt-3">
          <button className="blank-btn">Cancel</button>
          <button className="filled-btn">
            Update
            <img src={ic_arrow_right_white} alt="" />
          </button>
        </div> */}
      </div>

      {/* Reusable Confirmation Modal */}
      <ConfirmModal
        show={showConfirm}
        title="Confirm Delete"
        message="Are you sure you want to delete this address?"
        confirmText="Delete"
        confirmVariant="danger"
        onConfirm={deleteAddress}
        onCancel={handleCancel}
        loading={deleteAddressLoading}
      />
    </div>
  );
};
const customStyles = {
  control: (provided, state) => ({
    ...provided,
    backgroundColor: 'transparent',
    border: 'none',
    borderBottom: '1px solid #000', // The underline
    borderRadius: '0',
    boxShadow: 'none',
    '&:hover': {
      borderBottom: '1px solid #000'
    },
    padding: '0',
    minHeight: 'auto'
  }),
  valueContainer: (provided) => ({
    ...provided,
    padding: '0' // Removes default left padding
  }),
  indicatorSeparator: () => ({
    display: 'none' // Removes the vertical line before the arrow
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    padding: '0',
    color: '#999' // Adjust arrow color to match your image
  })
};
export default MyProfileComp;
